import React from 'react';
import { Link, Typography } from '@mui/material';
import GlassCard from '../../customs/GlassCard';
import ParentFormContainer from './ParentFormContainer';

const ParentFormClosedCapacity = ({ angelTreeTimeline }) => {
  let currentYear = new Date(
    angelTreeTimeline?.registration?.startDate
  ).getFullYear();

  return (
    <ParentFormContainer sx={{ display: 'flex', justifyContent: 'center' }}>
      <GlassCard sx={{ marginTop: 5, width: '70%', textAlign: 'center' }}>
        <Typography variant='h6' component='h6' color='secondary'>
          Thank you for your interest in the {currentYear} Angel Tree Program!
        </Typography>

        <br />
        <Typography variant='h6' component='h6' color='secondary'>
          We regret to inform you that this year’s program has reached full
          capacity. If you have any questions, please feel free to contact us at{' '}
          <Link color='secondary' href='mailto:angeltree@ufvsus.ca'>
            angeltree@ufvsus.ca
          </Link>
          .
        </Typography>
      </GlassCard>
    </ParentFormContainer>
  );
};

export default ParentFormClosedCapacity;
